import { render, staticRenderFns } from "./AccountPaymentBalance.vue?vue&type=template&id=2506c2dc&scoped=true&"
import script from "./AccountPaymentBalance.vue?vue&type=script&lang=js&"
export * from "./AccountPaymentBalance.vue?vue&type=script&lang=js&"
import style0 from "./AccountPaymentBalance.vue?vue&type=style&index=0&id=2506c2dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2506c2dc",
  null
  
)

export default component.exports